const useValidator = (value) => {
    class Validator {
        constructor(v) {
            this.value = v;
            this.validators = [];
            this.messages = [];
        }

        addValidation(validatorFn, message) {
            this.validators.push(validatorFn);
            this.messages.push(message);
            return this;
        }

        addErrorCallback(cb) {
            this.errorCb = cb;
            return this;
        }

        addSuccessCallback(cb) {
            this.successCb = cb;
            return this;
        }

        async run() {
            let valid = true;
            let i = 0;
            while (i < this.validators.length) {
                valid = await this.validators[i](this.value);
                if (!valid) {
                    break;
                }
                i++;
            }
            if (valid) {
                this.successCb();
            } else {
                this.errorCb(this.messages[i]);
            }
        }
    }
    return new Validator(value);
};

export default useValidator;
